import { styled, TextField } from '@mui/material';
import { createCartoonTextStyles } from '../theme';



export const CartoonTextField = styled(TextField)(
    ({ theme }) => {
        return {
            ...createCartoonTextStyles(theme),
            // height: '70px',
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: 'none', // Remove the default border
                },
                '&:hover fieldset': {
                    border: 'none', // Remove the border when hovering
                },
                '&.Mui-focused fieldset': {
                    border: 'none', // Remove the border when focused
                },
            },
            '& .MuiInputLabel-root': {
                transform: 'translate(10px, 15px) scale(1)', // Initial position
                color: theme.palette.grey[800],
            },
            '& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.MuiInputLabel-shrink': {
                transform: 'translate(10px, 1px) scale(0.6)', // Adjust the position when focused or with text
                color: theme.palette.grey[800],
            },
        }
    }


);
